import React, {FC, useState, InputHTMLAttributes, useEffect, useCallback} from 'react'
import {ID, isNotEmpty, KTSVG, QUERIES} from '../../../helpers'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {useNavigate, useSearchParams} from 'react-router-dom'
import * as Yup from 'yup'
import {useQuery, useQueryClient} from 'react-query'
import {useFormik} from 'formik'
import {useParams} from 'react-router-dom'
import {Tag} from './core/_models'
import {taskPriorityOptions} from '../../../../app/modules/project/components/tasks-list/core/_models'
import {TaskChecklistEditor} from '../../../../app/modules/project/components/tasks-list/TaskChecklist/TaskChecklistEditor'
import {OverviewAttachement} from '../../../../app/modules/project/components/tasks-list/TaskAttachment/OverviewAttachment'
import {UsersSymbolGroup} from '../../../../app/modules/project/components/projects-list/UsersSymbolGroup'
import {createTask, getUsersInstanceTask} from './core/_requests'
import {Toast} from '../../widgets'
import {Loading} from '../../components/loading/Loading'
import {useAuth, useHasModule} from '../../../../app/modules/auth'
import {getProjectById} from '../../../../app/modules/project/components/core/_requests'
import {SelectAutoComplete} from '../../components/Select/SelectAutoComplete'
import {CreateProjectAndClient} from '../create-project-and-client/CreateProjectAndClientModal'
import {getStageById} from '../../../../app/modules/stages/components/core/_requests'
import {TagsAutoComplete} from './components/TagsAutoComplete'
import {UsersSymbolGroupColumn} from '../../../../app/modules/project/components/tasks-list/UsersSymbolGroupColumn'
import {TaskSequenceResponsibles} from '../../../../app/modules/project/components/tasks-list/task-edit-modal/TaskSequenceResponsibles'
import {Alert, Form, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import CreatableSelect from 'react-select/creatable'
import {CKEditor} from '@ckeditor/ckeditor5-react'
import SourceEditingEditor from 'ckeditor5-build-classic-source-editing'
import StripColorsOnPaste from '../../components/rich-text-edit/plugins/StripColorsOnPaste'
import {TaskDateTimeFields} from '../../../helpers/TaskDateTimeFields'
import {normalizeIncomingTaskDateTime, toDatePickerValue, isValidTaskDateTimeRange} from '../../../helpers/TaskDateTime'
import dayjs from 'dayjs'
import {getTaskTemplateById} from '../../../../app/modules/task-templates/core/_requests'
import {useGetTaskTemplates} from '../../../../app/modules/task-templates/components/table/hooks/useGetTaskTemplates'
import Select from 'react-select'
import {TaskTemplatesSelect} from './components/TaskTemplatesSelect'
import {Subtasks} from '../../../../app/modules/project/components/tasks-list/task-edit-modal/Subtasks'
import {TaskRecurrence} from './components/TaskRecurrence'
import {getServerErrorMessage} from '../../../helpers/apiError'
import {invalidateAfterTaskChange} from '../../../helpers/taskQueryInvalidation'
import {getTaskAttachmentError} from '../../../helpers/taskAttachment'

type Props = {
  handleClose: () => void | undefined
  stageId: ID | string
  sprintId: ID | undefined
  initialTaskName?: string
  initialTaskDate?: string
  initialDescription?: string
  initialProjectId?: string | number
  initialPriority?: string
  initialIsPublic?: boolean
  initialAttachments?: Array<{id: number; file: string; file_name: string}>
  initialClientPortalTicketId?: number
  onTaskCreated?: (taskId: number) => void
}

interface checkProps extends InputHTMLAttributes<HTMLInputElement> {
  content: string
  check: boolean
}

interface checkPropsFile extends InputHTMLAttributes<HTMLInputElement> {
  file: any
}

interface responsibeProps extends InputHTMLAttributes<HTMLInputElement> {
  image: string
  name: string
}

const priorityOptions = taskPriorityOptions

const TaskModalContent: FC<Props> = ({
  handleClose,
  stageId,
  sprintId,
  initialTaskName,
  initialTaskDate,
  initialDescription,
  initialProjectId,
  initialPriority,
  initialIsPublic,
  initialAttachments,
  initialClientPortalTicketId,
  onTaskCreated,
}) => {
  const intl = useIntl()
  const [selectedOptions, setSelectedOptions] = useState([] as Tag[])
  const [checks, setChecks] = useState<Array<checkProps>>([])
  const [checksFile, setChecksFile] = useState<Array<checkPropsFile>>([])
  const queryClient = useQueryClient()
  const [status_name, setStatusName] = useState('')
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  var today = new Date().toISOString().split('T')[0]
  const {project_id} = useParams()

  const [showProjectAndClientModal, setShowProjectAndClientModal] = useState<boolean>(false)

  // Estado para o date range picker
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const [selectedTemplateData, setSelectedTemplateData] = useState<any>()
  const [descriptionKey, setDescriptionKey] = useState(0)
  const [ticketAttachments, setTicketAttachments] = useState<Array<{id: number; file: string; file_name: string}>>([])

  const {data: templates = []} = useGetTaskTemplates()
  const options = templates.map((template: any) => ({
    value: template.id,
    label: template.name,
  }))

  const handleIconClick = () => {
    setIsMenuOpen((prev) => !prev)
  }

  useQuery(
    `get-task-template-by-id-${searchParams.get('templateId')}`,
    () => getTaskTemplateById(parseInt(searchParams.get('templateId') ?? '')),
    {
      onSuccess: (data) => setSelectedTemplateData(data),
      enabled: !!searchParams.get('templateId'),
      cacheTime: 0,
      onError: (err) => {
        console.error(err)
      },
    }
  )

  useEffect(() => {
    if (!selectedTemplateData) return

    formik.setFieldValue('name', selectedTemplateData.name)
    formik.setFieldValue('description', selectedTemplateData.description)
    formik.setFieldValue('priority', selectedTemplateData.priority)
    setSelectedOptions(selectedTemplateData.tags)
    formik.setFieldValue('users', selectedTemplateData.users)

    setChecks(
      selectedTemplateData?.checklists?.map((checklist: any) => ({
        content: checklist.name,
        check: checklist.concluded,
      })) ?? []
    )

    // Subtarefas definidas no modelo de tarefa (task_templates.parent_id → pai)
    if (selectedTemplateData.subtasks?.length) {
      formik.setFieldValue(
        'subtasks',
        selectedTemplateData.subtasks.map((st: any) => ({
          name: st.name ?? '',
          priority: st.priority ?? undefined,
        }))
      )
    } else {
      formik.setFieldValue('subtasks', [])
    }
  }, [selectedTemplateData])

  // Lista de modelos pode vir sem `subtasks`; busca o detalhe para preencher subtarefas no modal
  useEffect(() => {
    if (!selectedTemplateData?.id) return
    if (selectedTemplateData.subtasks?.length) return

    let cancelled = false
    ;(async () => {
      try {
        const full = await getTaskTemplateById(selectedTemplateData.id)
        if (cancelled) return
        setSelectedTemplateData((prev: any) => ({...prev, ...full}))
      } catch {
        // ignore
      }
    })()
    return () => {
      cancelled = true
    }
  }, [selectedTemplateData?.id])

  // useEffect para preencher os dados iniciais quando o modal abrir
  useEffect(() => {
    if (initialTaskName) {
      formik.setFieldValue('name', initialTaskName)
    }
    if (initialDescription) {
      formik.setFieldValue('description', initialDescription)
      setDescriptionKey(prev => prev + 1)
    }
    if (initialProjectId) {
      formik.setFieldValue('project_id', String(initialProjectId))
    }
    if (initialPriority) {
      // Mapear prioridade do ticket para prioridade da tarefa
      const priorityMap: {[key: string]: string} = {
        'low': 'baixa',
        'medium': 'media',
        'high': 'alta',
        'critical': 'critica'
      }
      formik.setFieldValue('priority', priorityMap[initialPriority] || initialPriority)
    }
    if (initialTaskDate) {
      formik.setFieldValue(
        'expected_date',
        normalizeIncomingTaskDateTime(initialTaskDate, 'expected')
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialTaskName, initialDescription, initialProjectId, initialPriority, initialTaskDate])

  // Carregar anexos do ticket quando o modal abrir
  useEffect(() => {
    if (initialAttachments && initialAttachments.length > 0) {
      setTicketAttachments(initialAttachments)
    } else {
      setTicketAttachments([])
    }
  }, [initialAttachments])

  useEffect(() => {
    formik.setFieldValue('creator_id', currentUser?.id)
    // Só definir project_id da URL se não houver initialProjectId
    if (!initialProjectId) {
      formik.setFieldValue('project_id', project_id)
    }
    formik.setFieldValue('sprintId', sprintId)

    if (stageId !== undefined && typeof stageId != 'string') {
      ;(async () => {
        await getStageById(stageId).then((response) => {
          setStatusName(response.stages.name!)
          formik.setFieldValue('status', stageId)
        })
      })()
    } else {
      if (stageId) setStatusName(stageId[0].toUpperCase() + stageId.substring(1))
    }
  }, [])

  const effectiveProjectId = initialProjectId ? String(initialProjectId) : project_id

  const {
    isLoading,
    data: project,
    error,
  } = useQuery(
    `${QUERIES.TASKS_LIST}-project-${effectiveProjectId!}`,
    () => {
      return getProjectById(parseInt(effectiveProjectId!))
    },
    {
      enabled: !!effectiveProjectId,
      cacheTime: 0,
      onError: (err) => {
        console.error(err)
      },
    }
  )

  const {data: dataConst} = useQuery(
    `${QUERIES.TASKS_LIST}-usersTask`,
    () => {
      return getUsersInstanceTask()
    },
    {
      cacheTime: 0,
      onError: (err) => {
        console.error(err)
      },
      refetchOnWindowFocus: false,
    }
  )

  const {currentUser, auth} = useAuth()
  const hasTaskTemplatesModule = useHasModule('modelos-de-tarefas')

  const initialValues = {
    file: [],
    name: initialTaskName || '',
    description: initialDescription || '',
    begin_date: '',
    expected_date: initialTaskDate ? normalizeIncomingTaskDateTime(initialTaskDate, 'expected') || '' : '',
    project_id: initialProjectId ? String(initialProjectId) : (project_id ? String(project_id) : ''),
    checklist_concluded: [],
    checklist_name: [],
    users: [],
    tags: [],
    sequence_responsibles: [],
    priority: initialPriority || null,
    subtasks: [],
    recurrence: null,
    is_public: initialIsPublic !== undefined ? initialIsPublic : false,
  }

  const createAccountSchemas = [
    Yup.object().shape({
      name: Yup.string().required(intl.formatMessage({id: 'FORM.INPUT.VALIDATION.REQUIRED'})),
    }),
  ]

  const [currentSchema, setCurrentSchema] = useState(createAccountSchemas[0])

  const handleCreateProjectAndClient = (newProjectName: string) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set('new_project_name', newProjectName)
    setSearchParams(newParams)
    setShowProjectAndClientModal(true)
  }

  const formik = useFormik({
    initialValues,
    validationSchema: currentSchema,
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true)
      try {
        if (isNotEmpty(values.name)) {
          if (
            values.begin_date &&
            values.expected_date &&
            !isValidTaskDateTimeRange(values.begin_date, values.expected_date)
          ) {
            Toast.fire({
              icon: 'error',
              title: 'Data de início não pode ser posterior à data de vencimento',
              customClass: {
                popup: 'bg-light-danger',
                title: 'text-danger',
              },
            })
            setSubmitting(false)
            return
          }

          // Recusar aqui evita o envio e diz qual arquivo o servidor recusaria (tipo ou tamanho).
          // values.file é inferido como never[] a partir do initialValues, por isso o cast.
          const attachmentError = ((values.file ?? []) as any[])
            .filter((file): file is File => file instanceof File)
            .map((file) => getTaskAttachmentError(file))
            .find((error) => error !== null)
          if (attachmentError) {
            Toast.fire({
              icon: 'error',
              title: attachmentError,
              timer: 8000,
              customClass: {
                popup: 'bg-light-danger',
                title: 'text-danger',
              },
            })
            setSubmitting(false)
            return
          }

          // Adicionar client_portal_ticket_id se fornecido
          const taskData = initialClientPortalTicketId
            ? {...values, client_portal_ticket_id: initialClientPortalTicketId}
            : values
          const response = await createTask(taskData, selectedTemplateData?.id)
          
          Toast.fire({
            icon: 'success',
            title: intl.formatMessage(
              {id: 'ALERT.LABEL.SUCCESS_TASK_CREATE_ITEM'},
              {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
            ),
            customClass: {
              popup: 'bg-light-success',
              title: 'text-success',
            },
          })

          if (onTaskCreated && response.tasks) {
            const taskId = typeof response.tasks === 'number' 
              ? response.tasks 
              : (typeof response.tasks === 'object' && response.tasks?.id ? response.tasks.id : null)
            
            if (taskId && typeof taskId === 'number') {
              try {
                await Promise.resolve(onTaskCreated(taskId))
              } catch (callbackError) {
              }
            }
          }

          resetForm()
          handleClose()
          const newParams = new URLSearchParams(searchParams)
          const taskIdForUrl = typeof response.tasks === 'number' 
            ? response.tasks 
            : (typeof response.tasks === 'object' && response.tasks?.id ? response.tasks.id : null)
          if (taskIdForUrl) {
            newParams.set('taskId', String(taskIdForUrl))
          }
          setSearchParams(newParams)
          invalidateAfterTaskChange(queryClient)
        }
      } catch (ex) {
        console.error(ex)
        // O motivo vem do servidor (anexo grande, projeto fechado, usuário inválido...). O texto
        // genérico só entra quando a resposta não trouxe nenhum motivo.
        Toast.fire({
          icon: 'error',
          title: getServerErrorMessage(ex) ?? intl.formatMessage({id: 'ALERT.LABEL.ERROR'}),
          timer: 8000,
          customClass: {
            popup: 'bg-light-danger',
            title: 'text-danger',
          },
        })
      } finally {
        setSubmitting(false) // Corrigido: era setSubmitting(true)
      }
    },
  })

  const submitForm = useCallback(
    async (e: any) => {
      formik.setFieldValue('tags', selectedOptions)

      formik.setFieldValue(
        'checklist_concluded',
        checks.map((check, index) => {
          return check.check
        })
      )

      formik.setFieldValue(
        'checklist_name',
        checks.map((check, index) => {
          return check.content
        })
      )

      formik.setFieldValue(
        'file',
        checksFile.map((file, index) => {
          return file.file
        })
      )

      if (typeof stageId == 'string') formik.setFieldValue('status_name', status_name)

      formik.submitForm()
    },
    [formik]
  )

  return (
    <>
      <div className='modal-content task-modal-content'>
        <form
          id='kt_modal_add_project_milestone_form'
          className='form'
          onSubmit={(e) => e.preventDefault()}
          noValidate
        >
          <div className='modal-header border-0 flex-wrap'>
            <div className='col-10 col-md-8 order-1'>
              <input
                placeholder={intl.formatMessage({id: 'FORM.INPUT.NAME.TASK_TITLE'})}
                type='text'
                autoFocus
                className={clsx('form-control py-2 bg-transparent border-0 fs-1')}
                autoComplete='off'
                disabled={formik.isSubmitting}
                {...formik.getFieldProps('name')}
                onChange={(e) => {
                  formik.setFieldValue('name', e.target.value)
                }}
                onKeyPress={(e) => {
                  e.key === 'Enter' && e.preventDefault()
                }}
              />
            </div>

            {/* No mobile, o grupo de avatares não cabe ao lado do título — desce pra uma
                linha própria (col-12) em vez de ficar oculto (era `d-none d-md-flex`, sem
                nenhuma forma de ver/editar responsáveis pelo cabeçalho no celular). */}
            <div className='col-12 col-md-3 order-3 order-md-2 d-flex justify-content-start justify-content-md-end mt-3 mt-md-0'>
              {formik.values.sequence_responsibles.length > 0 ? (
                <UsersSymbolGroupColumn
                  users={formik.values.sequence_responsibles}
                  usersAll={dataConst?.users!}
                  isReadonly={true}
                />
              ) : dataConst?.users?.length! > 0 ? (
                <UsersSymbolGroup
                  users={dataConst?.users!}
                  classes='justify-content-end'
                  onChange={(users) => formik.setFieldValue('users', users)}
                  responsibles={selectedTemplateData ? formik.values.users : undefined}
                />
              ) : null}
            </div>
            <button
              className='col-2 col-md-1 order-2 order-md-3 btn btn-sm btn-icon btn-active-color-primary h-auto ms-md-4'
              onClick={(e) => {
                if (e.detail === 0) return
                handleClose()
              }}
            >
              <KTSVG
                className='svg-icon-2x svg-icon-gray-800'
                path='/media/icons/duotune/arrows/arr061.svg'
              />
            </button>
          </div>
          <div className='modal-body d-flex flex-column flex-lg-row justify-content-between'>
            <div className='col-lg-8 pe-md-5 pb-5 pb-lg-0 mb-15 mb-lg-0 border-bottom border-bottom-lg-0 d-flex flex-column'>
              <ul
                className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap overflow-x-scroll overflow-y-hidden'
                role='tablist'
              >
                <li className='nav-item'>
                  <a
                    className='nav-link cursor-pointer text-gray-900 active'
                    data-bs-toggle='tab'
                    href='#kt_task_description_pane'
                  >
                    Descrição
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link cursor-pointer text-gray-900'
                    data-bs-toggle='tab'
                    href='#kt_task_attachments_pane'
                  >
                    {intl.formatMessage({id: 'TASK.TABLE.ATTACHMENTS'})}
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link cursor-pointer text-gray-900'
                    data-bs-toggle='tab'
                    href='#kt_task_checklist_pane'
                  >
                    {intl.formatMessage({id: 'TASK.TABLE.CHECKLIST'})}
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link cursor-pointer text-gray-900 d-flex align-items-center'
                    data-bs-toggle='tab'
                    href='#kt_task_subtasks_pane'
                  >
                    <span>{intl.formatMessage({id: 'TASK.TABLE.SUBTASKS'})}</span>
                    <span className='badge badge-light-primary ms-2'>
                      {formik.values.subtasks?.length || 0}
                    </span>
                  </a>
                </li>
                <li className='nav-item align-items-center'>
                  <a
                    className='nav-link cursor-pointer text-gray-900'
                    data-bs-toggle='tab'
                    href='#kt_task_responsible_sequence_pane'
                  >
                    {intl.formatMessage({id: 'TASK.TABLE.RESPONSIBLE_SEQUENCE'})}
                  </a>
                  <OverlayTrigger
                    placement='top'
                    delay={{show: 50, hide: 100}}
                    overlay={
                      <Tooltip>
                        Crie uma sequência de responsáveis e organize a passagem de bastão da
                        tarefa. Assim, ao entregar uma parte, a tarefa será transferida de forma
                        automática para o próximo usuário.
                      </Tooltip>
                    }
                  >
                    <i className='fas fa-exclamation-circle mx-2 fs-7' />
                  </OverlayTrigger>
                </li>
              </ul>
              <div className='tab-content pt-3 overflow-y-scroll h-100'>
                <div
                  id='kt_task_description_pane'
                  className='task-ckeditor-container tab-pane fade show active'
                >
                  <CKEditor
                    // @ts-ignore
                    editor={SourceEditingEditor}
                    disabled={formik.isSubmitting}
                    id='description'
                    key={`description-${descriptionKey}`}
                    data={formik.values.description ?? ''}
                    onChange={(event: any, editor: any) =>
                      formik.setFieldValue('description', editor.getData())
                    }
                    config={{
                      extraPlugins: [StripColorsOnPaste],
                      toolbar: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        '|',
                        'link',
                        'blockQuote',
                        '|',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'uploadImage',
                      ],
                      simpleUpload: {
                        uploadUrl: `${process.env.REACT_APP_THEME_API_URL || process.env.REACT_APP_API_URL || ''}/api/upload`,
                        headers: {
                          Authorization: 'Bearer ' + auth?.api_token,
                        },
                      },
                    } as any}
                  />
                </div>

                <div id='kt_task_attachments_pane' className='tab-pane fade'>
                  <OverviewAttachement
                    mode='draft'
                    items={checksFile}
                    onChange={setChecksFile}
                    disabled={formik.isSubmitting}
                    readOnlySections={[
                      {title: 'Anexos do Ticket', attachments: ticketAttachments},
                      {
                        title: `${intl.formatMessage({id: 'ATTACHEMENT.TITLE'})} TEMPLATE`,
                        attachments: selectedTemplateData?.attachments ?? [],
                      },
                    ]}
                  />
                </div>

                <div id='kt_task_checklist_pane' className='tab-pane fade'>
                  <TaskChecklistEditor
                    items={checks}
                    onChange={setChecks}
                    disabled={formik.isSubmitting}
                  />
                </div>

                {!currentUser?.external_user && (
                  <>
                    <Subtasks
                      tabId='kt_task_subtasks_pane'
                      formikSetFieldValue={formik.setFieldValue}
                      tasks={formik.values.subtasks}
                      usersAll={dataConst?.users ?? []}
                    />

                    {/* sequence responsible */}
                    {dataConst?.users && (
                      <TaskSequenceResponsibles
                        tabId='kt_task_responsible_sequence_pane'
                        users={dataConst?.users!}
                        isCreate={true}
                        formikSetFieldValue={formik.setFieldValue}
                        responsibles={formik.values.sequence_responsibles}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
            <div className='col-lg-4 border-start-lg ps-lg-10'>
              <div className='border-bottom pb-8'>
                <div className='d-flex align-items-center mb-3'>
                  <i className='bi bi-calendar-range me-2 text-primary fs-5'></i>
                  <span className='fw-bold text-dark'>Datas</span>
                </div>

                <div className='d-flex align-items-center gap-3 mb-4'>
                  <div className='d-flex align-items-center gap-2'>
                    <i className='bi bi-calendar-plus text-muted fs-5'></i>
                    <span className='text-muted'>Início</span>
                    <i className='bi bi-arrow-right text-muted'></i>
                  </div>

                  <div className='d-flex align-items-center gap-2'>
                    <i className='bi bi-calendar-plus text-muted fs-5'></i>
                    <span className='text-muted'>Vencimento</span>
                  </div>
                </div>

                <TaskDateTimeFields
                  beginDateTime={formik.values.begin_date}
                  expectedDateTime={formik.values.expected_date}
                  onBeginDateTimeChange={(value) => formik.setFieldValue('begin_date', value)}
                  onExpectedDateTimeChange={(value) => formik.setFieldValue('expected_date', value)}
                  showExpectedDate={
                    !formik.values.sequence_responsibles?.some(
                      (responsible: any) =>
                        responsible?.expected_date &&
                        responsible.expected_date !== '' &&
                        responsible.expected_date !== 'null'
                    )
                  }
                  disabled={!!currentUser?.external_user}
                  minBeginDate={new Date()}
                  minExpectedDate={toDatePickerValue(formik.values.begin_date) || new Date()}
                />

                <div className='d-flex mb-4 mt-6'>
                  <span className='fw-bold text-dark me-1'>
                    {intl.formatMessage({id: 'TASK.LABEL.CREATOR_DEADLINE'})} {currentUser?.name}
                  </span>
                </div>
                {stageId && (
                  <div className='d-flex mb-4'>
                    <span className='fw-bold text-dark me-1'>
                      {intl.formatMessage({id: 'TASK.LABEL.STATUS'})} {status_name}
                    </span>
                  </div>
                )}
              </div>

              <div className='pt-10'>
                <div className='form-check form-check-custom form-check-solid'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id='is_public'
                    checked={formik.values.is_public}
                    onChange={(e) => formik.setFieldValue('is_public', e.target.checked)}
                    disabled={currentUser?.external_user}
                    style={{cursor: 'pointer'}}
                  />
                  <label
                    className='form-check-label fw-bold text-dark'
                    htmlFor='is_public'
                    style={{cursor: 'pointer'}}
                    onClick={(e) => {
                      if (!currentUser?.external_user) {
                        e.preventDefault()
                        const checkbox = document.getElementById('is_public') as HTMLInputElement
                        if (checkbox) {
                          checkbox.click()
                        }
                      }
                    }}
                  >
                    Tarefa Pública
                  </label>
                </div>
                <div className='form-text text-muted'>
                  Tarefas públicas serão visíveis na URL pública do projeto
                </div>
              </div>

              <div className='pt-4'>
                <div>
                  <label className='fw-bold text-dark me-1'>Prioridade:</label>
                  <CreatableSelect
                    isClearable={!currentUser?.external_user}
                    isDisabled={currentUser?.external_user}
                    placeholder={'Selecione a prioridade'}
                    options={priorityOptions}
                    value={
                      formik.values.priority && {
                        label: priorityOptions.find(
                          (option) => option.value === formik.values.priority
                        )?.label,
                        value: formik.values.priority,
                      }
                    }
                    onChange={(newValue) => {
                      if (newValue && typeof newValue === 'object' && 'value' in newValue) {
                        formik.setFieldValue('priority', newValue.value)
                      }
                    }}
                    classNames={{
                      control: (state) => 'form-control form-control-solid py-1',
                      input: (state) => 'text-dark',
                      singleValue: (state) => 'text-dark',
                      menu: (state) => 'bg-body',
                    }}
                    isSearchable={false}
                    styles={{
                      option: (styles, {data, isDisabled, isFocused, isSelected}) => {
                        return {
                          ...styles,
                          backgroundColor: isDisabled
                            ? undefined
                            : isSelected
                            ? '#b5d44e70'
                            : isFocused
                            ? '#b5d44e70'
                            : undefined,
                          color: isDisabled ? '#ccc' : isSelected ? '#181C32' : undefined,
                        }
                      },
                      clearIndicator(styles, props) {
                        return {
                          ...styles,
                          cursor: 'pointer',
                        }
                      },
                    }}
                  />
                </div>
              </div>

              <div className='pt-4'>
                <div>
                  <label className='fw-bold text-dark me-1'>Tags:</label>
                  <TagsAutoComplete
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    isDisabled={currentUser?.external_user}
                  />
                </div>
              </div>

              <div className='pt-4'>
                <div>
                  <span className='fw-bold text-dark me-1'>
                    {intl.formatMessage({id: 'TASK.LABEL.PROJECT'})}
                  </span>
                  <SelectAutoComplete
                    key={effectiveProjectId || 'project-select'}
                    endPoint='projetos'
                    value={
                      project && effectiveProjectId 
                        ? {value: effectiveProjectId, label: project?.name!} 
                        : undefined
                    }
                    placeholder={intl.formatMessage({id: 'FORM.INPUT.TOOLTIP.PROJECT'})}
                    onChange={(e) => {
                      if (e?.value) {
                        formik.setFieldValue('project_id', e.value)
                      }
                    }}
                    onCreateOption={(inputValue) => handleCreateProjectAndClient(inputValue)}
                    isDisabled={currentUser?.external_user}
                  />
                </div>
              </div>

              <div className='d-flex justify-content-between align-items-center text-center pt-7 gap-3'>
                <div className='d-flex gap-2 align-items-center'>
                  {hasTaskTemplatesModule && (
                    <TaskTemplatesSelect
                      selectedTemplate={selectedTemplateData}
                      setSelectedTemplate={setSelectedTemplateData}
                    />
                  )}
                  <TaskRecurrence
                    formikSetFieldValue={formik.setFieldValue}
                    recurrenceData={formik.values.recurrence}
                  />
                </div>

                <button
                  type='button'
                  className='btn btn-primary btn-sm px-8'
                  data-kt-users-modal-action='submit'
                  onClick={submitForm}
                  disabled={
                    formik.isSubmitting ||
                    !formik.isValid ||
                    !formik.touched ||
                    !formik.values.project_id
                  }
                >
                  <span className='indicator-label'>
                    {intl.formatMessage({id: 'GENERAL.CREATE_TASK'})}
                  </span>

                  {formik.isSubmitting && (
                    <span className='indicator-progress'>
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
        {formik.isSubmitting && <Loading />}
      </div>
      <CreateProjectAndClient
        show={showProjectAndClientModal}
        handleClose={() => setShowProjectAndClientModal(false)}
      />
    </>
  )
}

export {TaskModalContent}
